import { render } from "./EditDeathSideNav.vue?vue&type=template&id=5ca8d5f3"
import script from "./EditDeathSideNav.vue?vue&type=script&lang=js"
export * from "./EditDeathSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__